<template>
  <div class="s-layout" :style="colorObject">
    <Loading v-if="isLoading" loading-message="載入中..." :background-color="'#ffffff'" />
    <div class="s-container">
      <div class="content" :style="colors">
        <div class="custom-elanco-header">
          <span class="custom-elanco-header__text">Hi {{ deepGet(user, 'name') }}</span>
          <a :href="deepGet(event, 'config.header_logo_url', '#')">
            <img
              v-if="deepGet(event, 'config.images.header_logo')"
              :src="deepGet(event, 'config.images.header_logo')"
              class="custom-elanco-header__image ml-3"
            >
          </a>
        </div>

        <!-- page: redeem start -->
        <div v-if="page === 'redeem'">
          <img v-if="deepGet(event, 'config.images.redeem_confirm_kv')" :src="deepGet(event, 'config.images.redeem_confirm_kv')" alt="Elanco" class="img-fluid">

          <div class="py-3 px-4">
            <!-- Redeem Success Message (normal) -->
            <div v-if="isRedeemSuccess" class="redeem-success-message mb-3">
              {{ deepGet(event, 'config.universal_code_success_message', '兌換成功') }}
            </div>

            <!-- Redeem Notes Top -->
            <div class="redeem-notes redeem-notes--top mb-3" v-if="deepGet(event, 'config.redeem_notes_top')" v-html="deepGet(event, 'config.redeem_notes_top')">
            </div>

            <!-- Branch Code Input -->
            <div class="card__info">
              <input
                type="text"
                class="form-control-input"
                :placeholder="deepGet(event, 'config.branch_placeholder', '請輸入認證碼')"
                v-model="branchCode"
                :disabled="isRedeemSuccess"
              />
            </div>

            <!-- Package Dropdown -->
            <div class="card__info">
              <select
                class="form-control-input"
                v-model="packageName"
                :disabled="isRedeemSuccess"
              >
                <option value="" disabled>請選擇組數</option>
                <option
                  v-for="pkg in deepGet(event, 'config.redeem_package', [])"
                  :key="pkg.value"
                  :value="pkg.value"
                >{{ pkg.text }}</option>
              </select>
            </div>

            <!-- Redeem Notes Bottom -->
            <div class="redeem-notes redeem-notes--bottom mt-3" v-if="deepGet(event, 'config.redeem_notes_bottom')" v-html="deepGet(event, 'config.redeem_notes_bottom')">
            </div>

            <!-- Buttons Start -->
            <div class="btn-container">
              <button
                class="s-btn s-btn-xs redeem-submit-button"
                type="button"
                :disabled="isLoading || !branchCode || isRedeemSuccess || !packageName"
                @click="redeem"
              >
                確定送出
              </button>

              <!-- Button 1 -->
              <a v-for="button in buttons"
                :key="button.order"
                :href="button.button_url"
                :style="{ backgroundColor: button.button_bg_color, color: button.button_text_color }"
                class="s-btn s-btn-xs mt-3 d-block text-center">
                {{ button.button_text }}
              </a>

            </div>
            <!-- Buttons End -->
          </div>
        </div>
        <!-- page: redeem End -->

        <!-- Universal Code Modal -->
        <b-modal
          id="modal-universal-code"
          centered
          hide-header
          no-close-on-backdrop
          no-close-on-esc
          :footer-class="'universal-code-modal__footer'"
        >
          <div class="universal-code-modal__body">
            <!-- Title -->
            <div class="universal-code-modal__title" v-if="deepGet(event, 'config.universal_code_title')">
              {{ deepGet(event, 'config.universal_code_title') }}
            </div>

            <!-- Code Input -->
            <div class="universal-code-modal__field">
              <input
                type="text"
                class="form-control-input"
                :placeholder="deepGet(event, 'config.universal_code_placeholder', '請輸入萬用優惠碼')"
                v-model="universalCode"
              />
            </div>

            <!-- Clinic Input -->
            <div class="universal-code-modal__field" v-if="deepGet(event, 'config.clinic_title')">
              <div class="universal-code-modal__clinic-title">
                {{ deepGet(event, 'config.clinic_title') }}
              </div>
              <input
                type="text"
                class="form-control-input"
                :placeholder="deepGet(event, 'config.clinic_title_placeholder', '')"
                v-model="clinic"
              />
            </div>
          </div>

          <template #modal-footer>
            <button
              class="s-btn s-btn-xs universal-code-modal__btn-cancel"
              type="button"
              @click="closeUniversalCodeModal"
            >
              取消
            </button>
            <button
              class="s-btn s-btn-xs universal-code-modal__btn-submit"
              type="button"
              :disabled="isLoading || !universalCode"
              @click="redeemByUniversalCode"
            >
              送出
            </button>
          </template>
        </b-modal>

        <!-- page: empty message start-->
        <div v-if="page === 'empty_message'">
          <div class="card">
            <p class="alert-message">
              網址錯誤，沒有活動代碼
            </p>
          </div>
          <!-- 返回上一頁 -->
          <div class="btn-container">
            <button class="s-btn s-btn-bg-primary s-btn-xs" type="button" @click="goBack">
              返回上一頁
            </button>
          </div>
        </div>
        <!-- page: empty message end-->
      </div>
    </div>
  </div>
</template>

<script>
// Packages
import { mapGetters } from "vuex";
import { isAfter } from "date-fns";
import deepGet from "lodash/get";
// Waltily Utils
import { themeColorFn } from "@/mixins/liff/themeColor";
import dateOptionMixin from "@/mixins/liff/dateOption";
import https from "@/apis/liff/v2/https";
// Components
import Loading from "@/components/Page/Liff/Shared/Loading";
// Api
import redeemApi from "@/apis/liff/v2/redeem";

import { setTitle, setMeta } from '@/store/modules/liff/helpers';

export default {
  mixins: [
    themeColorFn({ themeConfigPage: 'redeem' }),
    dateOptionMixin,
  ],
  components: {
    Loading,
  },
  async mounted() {
    if (this.$route.query.event_code) {
      this.eventCode = this.$route.query.event_code;
    } else {
      this.$swal({
        text: '網址錯誤，沒有活動代碼',
        confirmButtonText: '確定',
      })
      this.page = 'empty_message';
      return;
    }

    await this.fetchEvent();
    this.setBrowserTitle();
  },
  data() {
    return {
      isLoading: false,
      eventCode: null,
      event: {
        config: {},
      },
      page: 'redeem', // redeem, empty_message
      branchCode: '',
      packageName: '',
      isRedeemSuccess: false,
      redeemedBranchName: '',
      error_message: [],
      universalCode: '',
      clinic: '',
    };
  },
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
      themeConfig: "liffGeneral/themeConfig",
    }),
    ...mapGetters("liffAuth", ["user"]),
    // 判斷 Event 是否在活動時間內
    isEventTime() {
      if (this.event) {
        const now = new Date();
        return isAfter(now, new Date(this.event.start_at)) && isAfter(new Date(this.event.end_at), now);
      }
      return false;
    },
    colors() {
      return {
        "--header_bg_color": this.event.config.header_bg_color,
        "--header_text_color": this.event.config.header_text_color,
        "--submit_bg_color" : this.event.config.submit_bg_color,
        "--submit_text_color": this.event.config.submit_text_color
      }
    },
    buttons() {
      return deepGet(this.event, 'config.buttons', []).sort((a, b) => a.order - b.order);
    }
  },

  methods: {
    deepGet,
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("liff_redeem", key);
    },
    async fetchEvent() {
      try {
        this.isLoading = true;

        const eventRes = await redeemApi.getRedeemEvent({
          event_code: this.eventCode,
        });

        this.event = eventRes.data.data.event;
        this.error_message = eventRes.data.data.event.config.error_message ?? [];

      } catch (error) {
        console.error(error);
        if (error.response?.status === 400) {
          const errorMessageConfig = this.findMappedError(error.response.data.message);
          this.$swal({
            text: deepGet(errorMessageConfig, 'message', '設定錯誤'),
            confirmButtonText: '確定',
          })
        } else {
          this.$swal({
            text: '活動資訊讀取失敗',
            confirmButtonText: '確定',
          })
        }
      } finally {
        this.isLoading = false;
      }
    },
    async redeem() {
      try {
        this.isLoading = true;

        if (!this.branchCode) {
          this.$swal({
            text: '請輸入認證碼',
            confirmButtonText: '確定',
          })
          return;
        }

        if (!this.eventCode) {
          this.$swal({
            text: '網址錯誤，沒有活動代碼',
            confirmButtonText: '確定',
          })
          return;
        }

        let response = await https.post(`${this.$store.state.liffGeneral.orgCode}/liff/elanco/advocate_2026/redeem`, {
          event_code: this.eventCode,
          branch_code: this.branchCode,
          package_name: this.packageName,
        });

        this.isRedeemSuccess = true;
        this.redeemedBranchName = this.deepGet(response, 'data.branch.name', '');
        const successMessage = this.deepGet(this.event, 'config.redeem_success_message', '已成功兌換');
        this.$swal({
          html: `【${this.redeemedBranchName}】<br><br>${successMessage}`,
          confirmButtonText: '確定',
        })
      } catch (error) {
        console.error(error);
        if (error.response?.status === 400) {
          const errorCode = error.response.data.message;
          // If enable_universal_code is true, show the universal code modal

          if (deepGet(this.event, 'config.universal_code_enable') === true) {
            this.$bvModal.show('modal-universal-code');
            return;
          }
          const errorMessageConfig = this.findMappedError(errorCode);
          this.$swal({
            text: deepGet(errorMessageConfig, 'message', '設定錯誤'),
            confirmButtonText: '確定',
          })
        } else {
          this.$swal({
            text: '發生錯誤，請稍後再試',
            confirmButtonText: '確定',
          })
        }
      } finally {
        this.isLoading = false;
      }
    },
    async redeemByUniversalCode() {
      this.isLoading = true;

      try {
        await https.post(`${this.$store.state.liffGeneral.orgCode}/liff/elanco/advocate_2026/redeem-by-universal-code`, {
          event_code: this.eventCode,
          package_name: this.packageName,
          code: this.universalCode,
          clinic: this.clinic,
        });

        this.$bvModal.hide('modal-universal-code');
        this.isRedeemSuccess = true;
        this.$swal({
          text: deepGet(this.event, 'config.universal_code_success_message', '萬用優惠碼兌換成功'),
          confirmButtonText: '確定',
        });
      } catch (error) {
        console.error(error);
        const failMessage = deepGet(this.event, 'config.universal_code_fail_message', '萬用優惠碼輸入錯誤，請重新輸入');
        this.$swal({
          text: failMessage,
          confirmButtonText: '確定',
        });
        this.universalCode = '';
      } finally {
        this.isLoading = false;
      }
    },
    closeUniversalCodeModal() {
      this.universalCode = '';
      this.clinic = '';
      this.$bvModal.hide('modal-universal-code');
    },
    findMappedError(code) {
      const errorMessageConfig = this.error_message ?? [];
      return errorMessageConfig.find(item => item.code === code);
    },
    goBack() {
      this.$router.go(-1);
    },
    setBrowserTitle() {
      if (this.event.config.browser_title) {
        setTitle(this.event.config.browser_title);
        setMeta('og:site_title', this.event.config.browser_title);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.form-control-input {
  width: 100%;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  padding: 0.8rem;
  line-height: var(--s-text-xl-line-height);
  color: var(--s-gray-darker);

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
}

.custom-elanco-header {
  padding: 16px;
  background-color: var(--header_bg_color);
  color: var(--header_text_color);
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__image {
    height: 40px;
  }
}

.redeem-notes {
  font-size: 14px;
  color: #333;
  line-height: 1.6;

  &--top {
    margin-bottom: 16px;
  }

  &--bottom {
    margin-top: 16px;
  }
}

.redeem-success-message {
  color: #fe0000;
  font-size: 14px;
  line-height: 1.6;
}

.redeem-submit-button {
  background-color: var(--submit_bg_color);
  color: var(--submit_text_color);
}

.btn-container {
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;
}

.universal-code-modal__body {
  padding: 8px 0;
}

.universal-code-modal__title {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 12px;
}

.universal-code-modal__field {
  margin-top: 12px;
}

.universal-code-modal__clinic-title {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 8px;
}

.universal-code-modal__btn-cancel {
  border: 1px solid var(--s-danger);
  color: var(--s-danger);
  background-color: #fff;
  flex: 1;
}

.universal-code-modal__btn-submit {
  background-color: var(--submit_bg_color, #93bf65);
  color: var(--submit_text_color, #fff);
  flex: 1;
}
</style>

<style lang="scss">
@import "../../../../assets/css/liff/main.css";
@import "../../../../assets/css/liff/liff_init_theme_config.css";
@import '../../../../assets/scss/shared/components/_fields.scss';

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
}

.s-container {
  min-height: 100vh;
  position: relative;
  max-width: 768px;
  margin: auto;
}

.s-layout,
.s-layout *,
.s-layout *:before,
.s-layout *:after {
  --s-secondary: #de006f;
  --s-warning: #ed6c00;
  --s-danger: #fe0000;
  --s-gray-darker: #363636;
  --s-gray-dark: #2c2c2e;
  --s-gray: #979797 !important;
  --s-gray-light: #c0c4cc;
  --s-gray-lighter: #f2f2f7;
  --liff-button-color: #93bf65;
  --liff-primary_text_color: #93bf65;
  --s-primary: #93bf65;
}

.content {
  height: 100vh;
  overflow-y: auto;
  margin: 0;
  padding-bottom: 24px;
  color: var(--liff-primary_text_color);
}

.card {
  margin-top: 24px;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 24px;
  margin-top: 12px;

  &__info {
    color: #636366;
    line-height: 24px;
    font-size: 16px;
    padding-top: 12px;
  }
}

.s-btn-primary {
  background-color: var(--liff-button-color) !important;
}

.s-btn-outline-primary {
  border-width: 3px !important;
}

.alert-message {
  text-align: center;
  color: var(--s-danger);
  font-size: 16px;
  padding: 12px;
  margin: 0;
}

.universal-code-modal__footer {
  display: flex;
  gap: 12px;
  justify-content: center;
}

#modal-universal-code___BV_modal_backdrop_ {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
